export const SEARCH_CONFIGURATIONS_DEFAULT_PAGE = 0;
export const SEARCH_CONFIGURATIONS_DEFAULT_SIZE = 3;
export const SEARCH_CONFIGURATIONS_SIZE = 10;
